export const cookieConsent = {
  cookieConsentTitle: "Koekies en privaatheid",
  cookieConsentMessage:
    "Ons gebruik koekies en soortgelyke tegnologieë om jou ervaring te verbeter en webgebruik te meet.",
  cookieConsentAcceptBtn: "Aanvaar",
  cookieConsentRejectBtn: "Wys af",
};
